import type { TFunction } from 'i18next'

interface SendFailure {
  errorCode: string | null
  errorMessage: string | null
}

/**
 * User-facing reason for a failed send. The backend's verbatim `error` text
 * wins when present — it carries context no static line can (which line the
 * STOP hit, when, how to recover). Without it, a known `error_code` maps to
 * its static reason; unknown codes and transport errors fall back to the
 * generic "couldn't send" line.
 */
export function sendErrorMessage(
  t: TFunction,
  { errorCode, errorMessage }: SendFailure,
): string {
  if (errorMessage) return errorMessage
  switch (errorCode) {
    case 'OPTED_OUT':
      return t('phonePanel.conversation.sendRejectedOptedOut')
    case 'ROUTE_BLOCKED':
      return t('phonePanel.conversation.sendRejectedBlocked')
    case 'CONTACT_UNDELIVERABLE':
      return t('phonePanel.conversation.sendRejectedUndeliverable')
    case 'IDEMPOTENT':
      return t('phonePanel.conversation.sendRejectedDuplicate')
    default:
      return t('phonePanel.conversation.sendError')
  }
}
